export const DEFAULT_FONT = 'medium';

export const fonts = [
    {title: 'Small', id: 'small'},
    {title: 'Medium', id: DEFAULT_FONT},
    {title: 'Large', id: 'large'}
];